import { render, staticRenderFns } from "./listaFaturas.vue?vue&type=template&id=a1e92e80&scoped=true&"
import script from "./listaFaturas.vue?vue&type=script&lang=js&"
export * from "./listaFaturas.vue?vue&type=script&lang=js&"
import style0 from "./listaFaturas.vue?vue&type=style&index=0&id=a1e92e80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e92e80",
  null
  
)

export default component.exports